import { render, staticRenderFns } from "./Repositories.vue?vue&type=template&id=382506c3&scoped=true&"
import script from "./Repositories.vue?vue&type=script&lang=js&"
export * from "./Repositories.vue?vue&type=script&lang=js&"
import style0 from "./Repositories.vue?vue&type=style&index=0&id=382506c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382506c3",
  null
  
)

export default component.exports